import script from "./ConfirmationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationView.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationView.vue?vue&type=style&index=0&id=dc6185f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc6185f6"]])

export default __exports__